<template>
	<div>
		<div class="line"></div>
		<div class="footer">
			<div class="footer-top">Flority</div>
			<div class="footer-icon">by HEARD（HK）LIMITED</div>
			<div class="footer-bottom">
				<div @click="toFuwu">Flority Terms of Service</div>
				<div @click="toYinsi">Privacy Policy</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {
			toFuwu() {
				this.$router.push({
					path: '/service'
				})
			},
			toYinsi() {
				this.$router.push({
					path: '/privacy'
				})
			}
		},
		mounted() {

		}
	}
</script>

<style lang="less" scoped>
	.line {
		height: 1px;
		background-color: #e4ebf3;
		margin: 0 1.25rem;
	}

	.footer {
		background: #fff;
		padding-top: 30px;
		padding-bottom: 0.5rem;

		.footer-top {
			font-family: 'C-B', sans-serif;
			font-size: 16px;
			font-weight: 700;
			letter-spacing: 2px;
			color: #1A1C2E;
			text-align: center;
			line-height: 1;
		}

		.footer-icon {
			font-size: 14px;
			color: #8a8f98;
			text-align: center;
			margin: 12px auto;
			line-height: 1;
		}

		.footer-bottom {
			display: flex;
			padding-bottom: 20px;

			div {
				flex: 1;
				text-align: center;
			}
		}
	}
</style>